const Vue = require("vue");

import { postRequest, getRequest } from "../../Helpers/api";
import { emailValidation } from "../../Helpers/validations";
import {modelMapper} from "../../Mappers";

import Comment from "./Components/Comment.vue";

// create vue instance for Comment
if (document.getElementById("js-comment")) {
  new Vue({
    el: "#js-comment",

    components: {
      Comment,
    },

    data() {
      return {
        commentViewDataModel: window.CommentViewData,
        comments: [],
        isAdding: false,
        loaded: false,
        hasMorePage: true,
        pageNumber: 1,
        totalCount: 0,
        loading: false,
        isSendLocked: false,
        remainingTimeToNextSend: 30,
        remainingTimeToNextSendTimer: null,

        name: {
          value: "",
          error: "",
          isValid: false,
        },

        email: {
          value: "",
          error: "",
          isValid: false,
        },

        commentMessage: {
          value: "",
          error: "",
          isValid: false,
        },
      };
    },

    created() {
      this.loadComments();

      this.loaded = true;
    },

    computed: {
      sendButtonText() {
        if (this.isAdding) {
          return "لطفا کمی صبر کنید";
        }

        if (this.isSendLocked) {
          return this.remainingTimeToNextSend + " ثانیه تا ارسال بعدی";
        }

        return "ارسال دیدگاه";
      },
      formIsValid() {
        if (
          this.name.isValid &&
          this.email.isValid &&
          this.commentMessage.isValid
        ) {
          return true;
        }
        return false;
      },
    },

    methods: {
      // get message data and send it
      sendComment(e) {
        e.preventDefault();
        if (!this.formIsValid) {
          return;
        }

        this.checkMessageIsValid();

        if (this.commentViewDataModel.isUserAuthenticated) {
          this.name.isValid = true;
          this.email.isValid = true;
        } else {
          this.checkEmailIsValid();
          this.checkNameIsValid();
        }

        if (
          this.name.isValid &&
          this.email.isValid &&
          this.commentMessage.isValid
        ) {
          this.isAdding = true;
          let newCommentData = {
            topicId: this.commentViewDataModel.topicId,
            message: this.commentMessage.value,
          };

          if (!this.commentViewDataModel.isUserAuthenticated) {
            newCommentData.name = this.name.value;
            newCommentData.email = this.email.value;
          }

          let payload = {
            url: this.commentViewDataModel.addUrl,
            data: newCommentData,
          };

          postRequest(payload).then((response) => {
            this.isAdding = false;

            if (response.isSucceed) {
              this.comments.push(response.model);
              this.name.value = "";
              this.email.value = "";
              this.commentMessage.value = "";

              if (!this.commentViewDataModel.isAdmin) {
                this.isSendLocked = true;
                this.lockSending();
              }
            }
          });
        }
      },

      // lock comment sending
      lockSending() {
        this.remainingTimeToNextSend = this.commentViewDataModel.timeBetweenAddComments;

        //  Count down timer
        this.remainingTimeToNextSendTimer = setInterval(() => {
          if (this.remainingTimeToNextSend <= 0) {
            clearInterval(this.remainingTimeToNextSendTimer);
            return;
          }

          this.remainingTimeToNextSend = this.remainingTimeToNextSend - 1;
        }, 1000);

        let timeOut = setTimeout(() => {
          this.isSendLocked = false;
          clearTimeout(timeOut);
        }, this.commentViewDataModel.timeBetweenAddComments * 1000);
      },

      // check email is valid or not
      checkEmailIsValid() {
        this.email.error = "";

        if (this.email.value !== null && this.email.value.length) {
          if (this.email.value.length) {
            let validEmail = emailValidation(this.email.value);

            if (validEmail) {
              this.email.isValid = true;
              this.email.error = "";
            } else {
              this.email.isValid = false;
              this.email.error = "ایمیل وارد شده معتبر نیست";
            }
          } else {
            this.email.isValid = false;
            this.email.error = "ورود ایمیل الزامی است";
          }
        } else {
          this.email.isValid = false;
          this.email.error = "ورود ایمیل الزامی است";
        }
      },

      // check name is valid or not
      checkNameIsValid() {
        this.name.error = "";

        if (this.name.value !== null && this.name.value.length) {
          if (!this.name.value.length) {
            this.name.isValid = false;
            this.name.error = "ورود نام و نام خانوادگی الزامی است";
          } else {
            this.name.isValid = true;
            this.name.error = "";
          }
        } else {
          this.name.isValid = false;
          this.name.error = "ورود نام و نام خانوادگی الزامی است";
        }
      },

      // check message is valid or not
      checkMessageIsValid() {
        this.commentMessage.error = "";

        if (
          this.commentMessage.value !== null &&
          this.commentMessage.value.length
        ) {
          if (!this.commentMessage.value.length) {
            this.commentMessage.isValid = false;
            this.commentMessage.error = "ورود پیام الزامی است";
          } else {
            this.commentMessage.isValid = true;
            this.commentMessage.error = "";
          }
        } else {
          this.commentMessage.isValid = false;
          this.commentMessage.error = "ورود پیام الزامی است";
        }
      },

      // show more comment
      loadComments() {
        this.loading = true;

        let payload = {
          url: `${this.commentViewDataModel.loadUrl}1/page/${this.pageNumber++}`,
        };

        getRequest(payload).then((response) => {
          this.loading = false;          

          if (response.model.comments && response.model.comments.length) {
            this.comments = [
              ...this.comments,
              ...modelMapper(response.model.comments),
            ];
          }

          this.hasMorePage = response.model.hasMorePages;
          this.totalCount = response.model.totalCount;          

        });
      },
    },
  });
}
